const email = (value, previousValue) =>
  value === '' ||
  /^[^()±!£$%^&*§¡€#¢§¶•ªº«\\/<>?:;|=,¿'`´¨ç{}/[ ]{1,200}$/.test(value.toLowerCase())
    ? value.toLowerCase()
    : previousValue;

const names = (value, previousValue) =>
  value === '' ||
  (/^[^±!@£$%^&*_+§¡€#¢§¶•ªº«\\/<>?:;|=.,0123456789-]{1,200}$/.test(value) &&
    value.trim() !== '' &&
    value.length - value.trim().length < 2)
    ? value
    : previousValue;

const normalizers = {
  email,
  names,
};

export default normalizers;
